import { render, staticRenderFns } from "./DetailPenerbitanDitolakPenilaianTeknis.vue?vue&type=template&id=54e8da66&"
import script from "./DetailPenerbitanDitolakPenilaianTeknis.vue?vue&type=script&lang=js&"
export * from "./DetailPenerbitanDitolakPenilaianTeknis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports